import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useFavorites } from "@/hooks/useFavorites";
import { PropertyCard } from "@/components/PropertyCard";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, Loader2, Search } from "lucide-react";

export default function Saved() {
  const { favorites } = useFavorites();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          favorites.map((id) =>
            api.get(`/listings/${id}`).then((r) => r.data).catch(() => null)
          )
        );
        if (active) setListings(results.filter(Boolean));
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [favorites]);

  return (
    <div className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
      <span className="label-caps text-[#D4A373]">Your shortlist</span>
      <h1 className="mt-2 font-display text-3xl font-medium tracking-tight text-[#1A1A1A]">
        Saved properties
      </h1>
      <p className="mt-1 text-[#6B7280]">Properties you've hearted, ready to revisit before you pay to unlock.</p>

      <div className="mt-8">
        {loading ? (
          <div className="flex h-40 items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-[#2C3830]" />
          </div>
        ) : listings.length === 0 ? (
          <div data-testid="saved-empty" className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-border py-24 text-center">
            <Heart className="h-10 w-10 text-[#D4A373]" />
            <p className="font-display text-xl text-[#2C3830]">No saved properties yet</p>
            <p className="text-sm text-[#6B7280]">Tap the heart on any listing to shortlist it here.</p>
            <Link to="/">
              <Button className="mt-2 rounded-full bg-[#2C3830] text-white">
                <Search className="mr-1.5 h-4 w-4" /> Browse properties
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {listings.map((l, i) => (
              <PropertyCard key={l.id} listing={l} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
